import { boolean } from 'yup'

export const applyBrand = boolean().default(false).meta({ hidden: true })
